module.exports = __webpack_public_path__ + "img/lolita-2.5b49e0d8.jpg";